/**
 * Pluralize a text by a given number
 *
 * pluralize(1, 'apple') => '1 apple'
 * pluralize(2, 'apple') => '2 apples'
 * pluralize(2, ['mouse', 'mice']) => '2 mice'
 * pluralize(2, 'apple', true) => 'apples'
 *
 * @param number number
 * @param original string|[string, string]  Singular text or an array contains [singular, plural]
 * @param hideNumber boolean? Whether to hide prefix number
 * @return string
 */
export const pluralize = (
    number: number,
    original: string | [string, string],
    hideNumber?: boolean,
): string => {
    const [singular, plural] = Array.isArray(original)
        ? original
        : [original, original + 's'];

    const text = number === 1 ? singular : plural;

    return hideNumber ? text : `${number} ${text}`;
};
